<template>

  <div class="tencent-map-container">
    <!-- 关键字输入框 -->
    <div class="search-box">
      <input v-model="searchKeyword"
             placeholder="请输入地点名称/地址"
             @input="handleKeywordInput"
             @blur="handleInputBlur"
             @focus="handleInputFocus">
      <!-- 关键字提示列表 -->
      <div class="suggest-wrap"
           v-show="showSuggestList && suggestList.length > 0">
        <ul class="suggest-list">
          <li v-for="(item, index) in suggestList"
              :key="index"
              @click="selectPlace(item)"
              class="suggest-item">
            <div class="title">{{ item.title }}</div>
            <div class="sub-title">{{ item.address || item.district }}</div>
          </li>
        </ul>
      </div>
    </div>

    <!-- 地图容器 -->
    <div id="tencent-map"
         class="map-container"></div>
    <div class="content-btn-check"
         style="width: 100%;">
      <button class="sure-desc-check widthmax"
              @click="setLocation">设定地址</button>
    </div>
  </div>
</template>

<script>
import Tmap from '../../api/model/tmap'
export default {
  name: 'TencentMap',
  data() {
    return {
      searchKeyword: '',
      suggestList: [],
      showSuggestList: false,
      map: null,
      marker: null,
      infoWindow: null,
      searchTimer: null,
      locationData: {
        lng: '',
        lat: '',
        address: '',
      },
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initMap()
    })
  },
  beforeDestroy() {
    clearTimeout(this.searchTimer)
    this.map = null
    this.marker = null
    this.infoWindow = null
  },
  methods: {
    initMap() {
      if (!window.qq || !window.qq.maps) {
        alert('腾讯地图加载失败，请检查网络或密钥')
        return
      }

      const defaultLatLng = new window.qq.maps.LatLng(39.908823, 116.39747)
      this.map = new window.qq.maps.Map(
        document.getElementById('tencent-map'),
        {
          center: defaultLatLng,
          zoom: 15,
          draggable: true,
          scrollwheel: true,
        }
      )

      this.marker = new window.qq.maps.Marker({
        position: defaultLatLng,
        map: this.map,
        zIndex: 999,
      })

      this.infoWindow = new window.qq.maps.InfoWindow({
        map: this.map,
        zIndex: 1000, 
        offset: new window.qq.maps.Size(0, -35), 
      })

      this.infoWindow.setContent()
      this.infoWindow.setPosition(defaultLatLng)
      this.infoWindow.open()
    },

    handleKeywordInput() {
      clearTimeout(this.searchTimer)
      const keyword = this.searchKeyword.trim()

      if (!keyword) {
        this.suggestList = []
        this.showSuggestList = false
        return
      }

      this.searchTimer = setTimeout(async () => {
        try {
          const response = await Tmap.suggestion(null, { key: keyword })
          const res = response.data
          if (res.length > 0) {
            this.suggestList = res
            this.showSuggestList = true
          } else {
            this.suggestList = []
            this.showSuggestList = false
          }
        } catch (error) {
          console.error('关键字搜索失败：', error)
          this.suggestList = []
          this.showSuggestList = false
        }
      }, 300)
    },

    selectPlace(place) {
      console.log(place)
      this.showSuggestList = false
      this.searchKeyword = place.title
      this.locationData.address=place.address
      this.locationData.lat=place.location.lat
      this.locationData.lng=place.location.lng
      // 严格校验经纬度
      if (
        !place.location ||
        isNaN(place.location.lat) ||
        isNaN(place.location.lng)
      ) {
        alert('该地点无有效坐标')
        return
      }

      const targetLatLng = new window.qq.maps.LatLng(
        Number(place.location.lat),
        Number(place.location.lng)
      )

      setTimeout(() => {
        this.map.panTo(targetLatLng)
      }, 100)

      this.marker.setPosition(targetLatLng)

      this.showInfoWindow(place, targetLatLng)
    },


    showInfoWindow(place, latLng) {
      if (!this.infoWindow) {
        this.infoWindow = new window.qq.maps.InfoWindow({
          map: this.map,
          zIndex: 1000,
          offset: new window.qq.maps.Size(0, -35),
        })
      }

      const content = `
        <div style="padding: 12px; width: 220px; border: 1px solid #eee; border-radius: 4px;">
          <h3 style="margin: 0 0 8px 0; font-size: 16px; color: #333;">${
            place.title || '未知地点'
          }</h3>
          <p style="margin: 0; font-size: 13px; color: #666;">${
            place.address || place.district || '无地址信息'
          }</p>
          <p style="margin: 4px 0 0 0; font-size: 12px; color: #999;">坐标：${latLng
            .getLat()
            .toFixed(6)}, ${latLng.getLng().toFixed(6)}</p>
        </div>
      `

      this.infoWindow.setPosition(latLng)
      this.infoWindow.setContent(content)
      this.infoWindow.open() 

      setTimeout(() => {
        this.infoWindow.open(this.map, this.marker)
      }, 200)
    },

    handleInputFocus() {
      if (this.suggestList.length > 0) {
        this.showSuggestList = true
      }
    },

    handleInputBlur() {
      setTimeout(() => {
        this.showSuggestList = false
      }, 200)
    },

    setLocation() {
      if (this.locationData.lng != '' && this.locationData.lat != '') {
        this.$bus.$emit(
          'setLocation',
          this.locationData.address,
          this.locationData.lng,
          this.locationData.lat
        )
      } else {
        this.$toast('请搜索地点。')
      }
    },
  },
}
</script>

<style scoped>
.tencent-map-container {
  width: 100%;
  height: 92%;
  position: relative;
}

.search-box {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 999;
  width: 360px;
}

.search-box input {
  width: 92%;
  padding: 10px 15px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  outline: none;
  box-sizing: border-box;
}

.search-box input:focus {
  border-color: #1677ff;
}

.suggest-wrap {
  margin-top: 4px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-height: 300px;
  overflow-y: auto;
}

.suggest-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.suggest-item {
  padding: 10px 15px;
  cursor: pointer;
  font-size: 14px;
}

.suggest-item:hover {
  background-color: #f5f7fa;
}

.suggest-item .title {
  font-weight: 500;
  color: #333;
}

.suggest-item .sub-title {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}

.map-container {
  width: 100%;
  height: 100%;
  z-index: 1; /* 确保地图容器层级正确 */
}
</style>